import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { AppContext } from '../../pages/layout';

type TClientDeleteHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutationResult<void, unknown, string, unknown>['mutate'];
};

function useDeleteClient(): TClientDeleteHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (id: string) => sdk.clients.delete(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries(['clients']);
      appContext?.crudAlert('delete', 'client', 'm');
      navigate('/settings/clients');
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useDeleteClient };
